export const handleAsync = async (func, errorCallback) => {
  try {
    const data = await func();

    return {
      data,
    };
  } catch (error) {
    if (errorCallback) {
      errorCallback(error);
    }

    return {
      error,
    };
  }
};
